import './promise-extends';
import SxAjax from './sx-ajax';
import _createAjaxHoc from './react-hoc';

export default SxAjax;
export const createAjaxHoc = _createAjaxHoc;
